import _classCallCheck from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _wrapNativeSuper from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
export var ProviderError = /*#__PURE__*/function (_Error) {
  _inherits(ProviderError, _Error);
  var _super = _createSuper(ProviderError);
  function ProviderError(message) {
    var _logger, _logger$debug;
    var _this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    _classCallCheck(this, ProviderError);
    var logger;
    var tryNextLink = true;
    if (typeof options === "boolean") {
      logger = undefined;
      tryNextLink = options;
    } else if (options != null && typeof options === "object") {
      var _options$tryNextLink;
      logger = options.logger;
      tryNextLink = (_options$tryNextLink = options.tryNextLink) !== null && _options$tryNextLink !== void 0 ? _options$tryNextLink : true;
    }
    _this = _super.call(this, message);
    _this.name = "ProviderError";
    _this.tryNextLink = tryNextLink;
    Object.setPrototypeOf(_assertThisInitialized(_this), ProviderError.prototype);
    (_logger = logger) === null || _logger === void 0 ? void 0 : (_logger$debug = _logger.debug) === null || _logger$debug === void 0 ? void 0 : _logger$debug.call(_logger, "@smithy/property-provider ".concat(tryNextLink ? "->" : "(!)", " ").concat(message));
    return _this;
  }
  _createClass(ProviderError, null, [{
    key: "from",
    value: function from(error) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return Object.assign(new this(error.message, options), error);
    }
  }]);
  return ProviderError;
}( /*#__PURE__*/_wrapNativeSuper(Error));